import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import StationContainer from '../../containers/Station';
import ReportsMonitoringForStationTankContainer from '../../containers/reports/MonitoringForStationTank';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import TableSortLabel from '@material-ui/core/TableSortLabel';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import {
	BarChart,
	Bar,
	Legend,
	ResponsiveContainer,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
} from 'recharts';
import Button from '@material-ui/core/Button';
import AddInventoryDialog from '../../components/AddInventoryDialog';
import ReportsMonitoringContainer from '../../containers/reports/Monitoring';
import AddDeliveryDialog from '../../components/AddDeliveryDialog';

const DWP_USER_ID = 14;

const styles = () => ({
	paper: {
		width: '100%',
		overflowX: 'auto',
		textAlign: 'left',
	},
	deliveryRow: {
		backgroundColor: '#E3F2FD',
	},
	weekendRow: {
		color: '#888',
		backgroundColor: '#eee',
	},
	label: {
		paddingRight: 10,
	},
	value: {
		fontWeight: 600,
	},
	avgSection: {
		padding: 30,
		textAlign: 'left',
		fontSize: 16,
	},
	sectionHeader: {
		textTransform: 'uppercase',
		fontSize: 14,
		color: '#777',
		fontWeight: 900,
		letterSpacing: 2,
		marginBottom: 20,
		marginTop: 20,
	},
	formControl: {
		fontSize: 14,
		marginLeft: 20,
	},
	title: {
		display: 'flex',
		alignItems: 'flex-end',
	},
	button: {
		verticalAlign: 'middle',
		padding: '8px 10px',
		borderRadius: '100px',
	},
});

const columnData = [
	{ id: 'eventDate', numeric: false, label: 'Event Date' },
	{ id: 'type', numeric: false, label: 'Type' },
	{ id: 'volume', numeric: false, label: 'Volume' },
	{ id: 'communicationStatusId', numeric: false, label: 'Communication Status' },
	{ id: 'source', numeric: false, label: 'Source' },
	{
		id: 'edit',
		padding: 'checkbox',
		label: 'Edit',
		style: { textAlign: 'center' },
		isNotSortable: true,
	},
];

class StationData extends Component {
	constructor(props) {
		super(props);

		const stationId = parseInt(_.get(this.props, ['match', 'params', 'stationId']), 10);
		const tankNumber = parseInt(_.get(this.props, ['match', 'params', 'tankNumber']), 10);

		this.state = {
			stationId,
			tankNumber,
			infoForAdd: {},
			isAddDialogOpen: false,
			isDeliveryDialogOpen: false,
		};
	}

	componentDidMount() {
		const { stationId, tankNumber } = this.state;

		if (!this.props.stationData) {
			this.props.getStationData({
				params: { stationId, tankNumber },
			});
		}

		if (!this.props.tankDailySales) {
			this.props.getTankDailySales({});
		}

		if (!this.props.station) {
			this.props.getStation({
				params: { stationIds: [stationId] },
			});
		}
	}

	handleAddNewInventory = () => {
		const { tankNumber } = this.state;
		const { station } = this.props;

		const { stationId, number, name } = station;

		this.setState({
			isAddDialogOpen: true,
			infoForAdd: {
				stationId,
				tankNumber,
				productType: 'e85',
				number,
				name,
			},
		});
	};

	handleAddNewDelivery = () => {
		const { tankNumber } = this.state;
		const { station } = this.props;

		this.setState({
			isDeliveryDialogOpen: true,
			infoForDelivery: {
				station,
				tankNumber,
			},
		});
	};

	handleUpdateDelivery = ({ deliveryRecordId, deliveryAmount, deliveryMoment }) => {
		const { tankNumber } = this.state;
		const { station } = this.props;

		this.setState({
			isDeliveryDialogOpen: true,
			infoForDelivery: {
				deliveryRecordId,
				station,
				tankNumber,
				deliveryAmount,
				deliveryMoment,
			},
		});
	};

	handleCloseDeliveryDialog = () => {
		this.setState({ isDeliveryDialogOpen: false });
	};

	//-- Inventory
	handleUpdateInventory = ({ inventoryRecordId, volume, inventoryMoment }) => {
		const { stationId, tankNumber } = this.state;
		const { station } = this.props;
		const { number, name } = station;

		this.handleOpenAddDialog({
			infoForAdd: {
				inventoryRecordId,
				stationId,
				tankNumber,
				number,
				name,
				volume,
				day: inventoryMoment,
			},
		});
	};

	handleOpenAddDialog = ({ infoForAdd }) => {
		this.setState({
			infoForAdd,
			isAddDialogOpen: true,
		});
	};

	handleCloseAddDialog = () => {
		this.setState({ isAddDialogOpen: false });
	};

	render() {
		const {
			classes,
			stationData,
			station,
			tankDailySales,
			tankDailyAverages,
			userMap,
			authUser,
		} = this.props;
		const { stationId, tankNumber } = this.state;

		if (!stationData || !station || !tankDailySales) {
			return <div>Fetching station data details...</div>;
		}

		const data = stationData.map((fillRecord) => {
			const isDelivery = !!fillRecord.endDateTime;
			const isGmoc = !!fillRecord.salesDate;

			if (isDelivery) {
				const { createdByUserId } = fillRecord;
				let source = 'Veeder';
				if (createdByUserId) {
					const user = userMap[fillRecord.createdByUserId] || {
						firstName: 'Missing',
						lastName: '',
					};
					source = `${user.firstName} ${user.lastName}`;
				}

				/** @namespace illRecord.adjustedDeliveryAmount **/
				return {
					isDelivery,
					eventDateFormatted: moment(fillRecord.endDateTime).format('M/D h:mm a'),
					type: 'Delivery',
					volume: fillRecord.adjustedDeliveryAmount,
					communicationStatus: 'Success',
					source,
					onClick: () => {
						this.handleUpdateDelivery({
							deliveryRecordId: fillRecord.deliveryRecordId,
							deliveryAmount: fillRecord.adjustedDeliveryAmount,
							deliveryMoment: moment(fillRecord.endDateTime),
						});
					},
				};
			} else if (isGmoc) {
				return {
					isDelivery,
					isGmoc: true,
					eventDateFormatted: moment(fillRecord.salesDate).format('M/D'),
					type: 'Sales Record',
					volume: fillRecord.volume,
					communicationStatus: 'Success',
					source: 'GMOC',
				};
			} else {
				const { veederRootSiteId } = fillRecord;
				let source = 'Veeder';
				if (fillRecord.createdByUserId) {
					const user = userMap[fillRecord.createdByUserId] || {
						firstName: 'Missing',
						lastName: '',
					};
					source = `${user.firstName} ${user.lastName}`;
				} else if (veederRootSiteId === 'Petromo') {
					source = 'Petromo';
				} else if (veederRootSiteId === 'PDI' || veederRootSiteId === 'Intellifuel') {
					if (fillRecord.waterVolume === -1) {
						source = 'KII (via PDI/Intellifuel)';
					} else {
						source = 'PDI / Intellifuel';
					}
				} else if (veederRootSiteId === 'Telapoint') {
					source = 'PDI / Telapoint';
				} else {
					source = veederRootSiteId;
				}

				return {
					isDelivery,
					eventDateFormatted: moment(fillRecord.inventoryDateTime).format('M/D h:mm a'),
					type: 'Inventory',
					volume: fillRecord.currentVolume,
					communicationStatus: fillRecord.communicationStatusId === 0 ? 'Success' : 'Error',
					source,
					onClick: () => {
						this.handleUpdateInventory({
							inventoryRecordId: fillRecord.inventoryRecordId,
							volume: fillRecord.currentVolume,
							inventoryMoment: moment(fillRecord.inventoryDateTime),
						});
					},
				};
			}
		});

		//- Daily average
		/*
		const myDailySales = _.find(tankDailySales, { stationId, tankNumber });
		const salesByDayOfWeek = _.groupBy(myDailySales.sales, sale => {
			return moment(sale.date).day();
		});
		const dowDisplay = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

		let averages = [];
		_.keys(salesByDayOfWeek).forEach(dow => {
			averages.push({
				name : dowDisplay[parseInt(dow, 10)],
				dow : dow,
				avg : _.meanBy(salesByDayOfWeek[dow], 'volume')
			});
		});
		averages  = _.sortBy(averages, 'dow');
		 */

		const myDailyAverages = _.find(tankDailyAverages, { stationId, tankNumber });
		let averages = [];
		if (myDailyAverages) {
			({ averages } = myDailyAverages);
		}
		/*
		let averages = [];
		if (tankDailyAverages) {
			averages = tankDailyAverages.averages;
		}
		 */

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<div>
						<Grid container spacing={2}>
							<Grid item xs={8}>
								<Typography variant="h5" align="left" gutterBottom className={classes.title}>
									<span>
										Station Reporting for {station.number} - {station.name} / Tank{' '}
										{this.state.tankNumber}
									</span>
								</Typography>
							</Grid>

							<Grid item xs={4} style={{ textAlign: 'right' }}>
								<Button
									variant="contained"
									color="primary"
									style={{
										borderRadius: 100,
										textDecoration: 'none',
										marginRight: 10,
										marginBottom: 10,
									}}
									onClick={this.handleAddNewInventory}
								>
									ADD INVENTORY VOLUME
								</Button>

								<Button
									variant="contained"
									color="primary"
									style={{
										borderRadius: 100,
										textDecoration: 'none',
										marginTop: 0,
										marginBottom: 10,
									}}
									onClick={this.handleAddNewDelivery}
								>
									ADD STATION DELIVERY
								</Button>
							</Grid>
						</Grid>

						<Paper className={classes.paper}>
							<div style={{ padding: 20 }}>
								Average per day of the week
								<ResponsiveContainer width="100%" height={300}>
									<BarChart data={averages} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
										<defs>
											<linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
												<stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8} />
												<stop offset="95%" stopColor="#82ca9d" stopOpacity={0} />
											</linearGradient>
											<linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
												<stop offset="5%" stopColor="#8884d8" stopOpacity={0.8} />
												<stop offset="95%" stopColor="#8884d8" stopOpacity={0} />
											</linearGradient>
										</defs>
										<XAxis dataKey="name" />
										<YAxis />
										<CartesianGrid strokeDasharray="3 3" />
										<Tooltip />
										<Legend verticalAlign="top" height={36} />
										<Bar
											type="monotone"
											name="28 day average"
											dataKey="average"
											stroke="#82ca9d"
											fillOpacity={1}
											fill="url(#colorPv)"
										/>
										<Bar
											type="monotone"
											name="28 day weighted average"
											dataKey="weightedAverage"
											stroke="#8884d8"
											fillOpacity={1}
											fill="url(#colorUv)"
										/>
									</BarChart>
								</ResponsiveContainer>
							</div>
						</Paper>

						<Paper className={classes.paper} style={{ marginTop: 20 }}>
							<div style={{ padding: 20 }}>
								Inventory and Delivery History
								<Table>
									<TableHead>
										<TableRow>
											{columnData.map((c) => {
												return (
													<TableCell key={c.id} align={c.numeric ? 'right' : 'left'}>
														<TableSortLabel>{c.label}</TableSortLabel>
													</TableCell>
												);
											}, this)}
										</TableRow>
									</TableHead>
									<TableBody>
										{data.map((n, i) => {
											return (
												<TableRow
													hover
													className={n.isDelivery ? classes.deliveryRow : ''}
													style={{ backgroundColor: n.isSelected ? '#ef9a9a' : undefined }}
													key={i}
												>
													<TableCell>{n.eventDateFormatted}</TableCell>
													<TableCell>{n.type}</TableCell>
													<TableCell>{n.volume}</TableCell>
													<TableCell>{n.communicationStatus}</TableCell>
													<TableCell>{n.source}</TableCell>
													<TableCell>
														{!n.isGmoc && (
															<Button className={classes.button} onClick={n.onClick}>
																Edit
															</Button>
														)}
														{n.isGmoc && (
															<span style={{ color: '#999' }}>G&M data not editable</span>
														)}
													</TableCell>
												</TableRow>
											);
										})}
									</TableBody>
								</Table>
							</div>
						</Paper>

						<AddInventoryDialog
							onClose={this.handleCloseAddDialog}
							addInventoryRecord={this.props.addInventoryRecord}
							updateInventoryRecord={this.props.updateInventoryRecord}
							infoForAdd={this.state.infoForAdd}
							open={this.state.isAddDialogOpen}
							showErrors={this.props.showErrors}
						/>

						<AddDeliveryDialog
							onClose={this.handleCloseDeliveryDialog}
							addDeliveryRecord={this.props.addDeliveryRecord}
							updateDeliveryRecord={this.props.updateDeliveryRecord}
							removeDeliveryRecord={this.props.removeDeliveryRecord}
							canDeleteDelivery={!!authUser && authUser.userId === DWP_USER_ID}
							infoForDelivery={this.state.infoForDelivery}
							open={this.state.isDeliveryDialogOpen}
							showErrors={this.props.showErrors}
						/>
					</div>
				</Grid>
			</Grid>
		);
	}
}

StationData.propTypes = {
	classes: PropTypes.object.isRequired,
	userMap: PropTypes.object,
	authUser: PropTypes.object,

	getStationData: PropTypes.func.isRequired,
	stationData: PropTypes.array,

	getTankDailySales: PropTypes.func.isRequired,
	tankDailySales: PropTypes.array,
	tankDailyAverages: PropTypes.array,

	getStation: PropTypes.func.isRequired,
	station: PropTypes.object,

	addInventoryRecord: PropTypes.func.isRequired,
	updateInventoryRecord: PropTypes.func.isRequired,

	addDeliveryRecord: PropTypes.func.isRequired,
	updateDeliveryRecord: PropTypes.func.isRequired,
	removeDeliveryRecord: PropTypes.func.isRequired,

	showErrors: PropTypes.func.isRequired,
};

export default _.flow([
	withStyles(styles),
	StationContainer,
	ReportsMonitoringForStationTankContainer,
	ReportsMonitoringContainer,
])(StationData);
